import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { KeyInformationCardStyles } from '@stories/Components/Cards/KeyInformationCard/KeyInformationCard.styles';
import { ResourceCardStyles } from '@stories/Components/Cards/ResourceCard/ResourceCard.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import { RelatedCardsStyles } from '../RelatedCards/RelatedCards.styles';
const Container = styled(SectionWrapper) `
  > ${SectionWrapperStyles.Inner} > ${SectionWrapperStyles.SiteWide} {
    padding-left: 0;
    padding-right: 0;
  }
`;
const Inner = styled.div `
  ${baseGrid};
  grid-template-columns: 100%;
  align-items: start;

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(4, 1fr);
    column-gap: var(--sitePadding);
  }
`;
const ArticleContent = styled.div `
  position: relative;
  margin-top: var(--sitePadding);

  @media ${from(Device.Tablet)} {
    grid-column: span 3;
    margin-top: 0;

    ${RelatedCardsStyles.CardsContainer} {
      width: calc(100% + var(--sitePadding) + var(--sitePadding));
      margin-left: calc(var(--sitePadding) * -1);
      padding: 0 var(--sitePadding);
    }
  }
`;
const SideContent = styled.div `
  position: relative;
  order: -1;
  display: grid;
  grid-template-columns: 100%;
  padding-left: var(--sitePadding);
  padding-right: var(--sitePadding);
  row-gap: var(--sitePadding);

  @media ${from(Device.Tablet)} {
    order: initial;
    padding-left: 0;
    padding-right: var(--sitePadding);
  }

  @media ${until(Device.Tablet)} {
    ${KeyInformationCardStyles.Container}:first-child {
      margin-top: -40px;
      margin-left: calc(var(--sitePadding) * -1);
      margin-right: calc(var(--sitePadding) * -1);
    }
  }

  &[data-mobile-only] {
    order: 0;
    padding-bottom: 40px;
  }

  ${ResourceCardStyles.Container} {
    height: auto;
  }
`;
export const ColumnedLayoutStyles = {
    ArticleContent,
    Container,
    Inner,
    SideContent,
};
